<template>
  <!-- 根节点刻意带 el-pagination 类名：各页面原有 scoped 的 .el-pagination 样式（margin-top/text-align 等）
       会通过子组件根元素继续生效，替换后 PC 端外观与原来完全一致、不回退 -->
  <div class="el-pagination smart-pagination-wrap">
    <!-- PC 端：布局由页面 layout 传入，与原生 el-pagination 表现一致 -->
    <el-pagination class="sp-pc" :layout="layout" :total="total" :current-page="currentPage"
      :page-size="pageSize" :page-sizes="pageSizes" :pager-count="pagerCount" :background="background"
      @size-change="handleSizeChange" @current-change="handleCurrentChange" />
    <!-- 手机端：页码号条挤压不好用，固定为 上一页/下一页 + 输入页码跳转，文字展示 总条数/当前页/总页数 -->
    <div class="sp-mobile">
      <span class="sp-mobile-info">共 {{ total }} 条 · 第 {{ currentPage }} / {{ totalPageCount }} 页</span>
      <el-pagination background layout="prev, next, jumper" :total="total" :current-page="currentPage"
        :page-size="pageSize" @current-change="handleCurrentChange" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'SmartPagination',
  props: {
    total: { type: Number, default: 0 },
    currentPage: { type: Number, default: 1 },
    pageSize: { type: Number, default: 10 },
    pageSizes: { type: Array, default: () => [10, 20, 50, 100] },
    pagerCount: { type: Number, default: 7 },
    // PC 端布局（原样传给 el-pagination）；手机端固定 prev/next/jumper，每页条数下拉在小屏不展示
    layout: { type: String, default: 'total, prev, pager, next, jumper' },
    background: { type: Boolean, default: false }
  },
  computed: {
    totalPageCount() {
      const size = Number(this.pageSize) || 10
      return Math.max(1, Math.ceil((Number(this.total) || 0) / size))
    }
  },
  methods: {
    handleSizeChange(val) {
      this.$emit('size-change', val)
    },
    handleCurrentChange(val) {
      this.$emit('current-change', val)
    }
  }
}
</script>

<style scoped>
.smart-pagination-wrap {
  /* 覆盖 element 自带 .el-pagination 的 white-space:nowrap，允许手机端信息行与按钮组换行 */
  white-space: normal;
}

.sp-mobile {
  display: none;
  align-items: center;
  justify-content: center;
  gap: 10px;
  flex-wrap: wrap;
}

.sp-mobile-info {
  font-size: 13px;
  color: #606266;
}

@media (max-width: 768px) {
  .sp-pc {
    display: none !important;
  }

  .sp-mobile {
    display: flex;
  }
}
</style>
